module.exports = __webpack_public_path__ + "7071ac52883a1ba712f1a010113270b3.jpg";